import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { Component, useState, useEffect } from "react";
import { scImageType, scLinkType, scStringType } from "../../types";
import { Image, RichText, Text } from "@sitecore-jss/sitecore-jss-react"; //Demonstrates usage of an Image content field within JSS.

import { Modal as BootstrapModal } from "react-bootstrap";
import PegIcon from "../../images/svg/PegIcon.svg";
import { Button } from "react-bootstrap";

var PegInformationModal = function PegInformationModal(props) {
  var fields = props.fields,
      show = props.show,
      hide = props.hide;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  useEffect(function () {
    var backgroundModal = document.getElementsByClassName("modal-backdrop")[0];

    if (backgroundModal) {
      // we style it to have z-index = 1050
      backgroundModal.style.zIndex = 1050;
    } // add an appropriate event listener, for sitecore integration


    window.addEventListener("openPegInfoModal", function (e) {
      setShowModal(e.detail.show && e.detail.show === true ? true : false);
    }); // This is is for storybook only

    if (show) {
      setShowModal(show || show === "true" ? true : false);
    }
  }, [show]);
  if (!fields) return null;
  var backgroundShape = fields.backgroundShape,
      button = fields.button,
      copy = fields.copy,
      currencyCopy = fields.currencyCopy,
      description = fields.description,
      image = fields.image,
      pegCounter = fields.pegCounter,
      termsConditions = fields.termsConditions,
      title = fields.title,
      pegIconAlt = fields.pegIconAlt;

  var closeModal = function closeModal(e) {
    // Make sure we have an event if not we close the modal (this ensures we can close the modal when clicking outside of it)
    if (!e) {
      setShowModal(false);
      return;
    } // If we have an event and it has a key and that key is escape then we close the modal


    if (e && e.key && e.key === "Escape") {
      setShowModal(false);
      return;
    }

    e.preventDefault();
    setShowModal(false);

    if (hide) {
      hide(true);
    }
  };

  return /*#__PURE__*/React.createElement(BootstrapModal, {
    className: "cb-modal__location-color--white loyalty-peg-modal",
    show: showModal,
    onHide: closeModal,
    backdrop: true,
    size: "lg",
    autoFocus: true,
    keyboard: true,
    backdropClassName: "loyalty-modal__backdrop"
  }, /*#__PURE__*/React.createElement(BootstrapModal.Header, {
    className: "cb-modal__title-color--white loyalty-peg-modal__header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "button cb-modal__close",
    onClick: closeModal
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: "0.16",
    cx: "12",
    cy: "12",
    r: "12",
    fill: "#653024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5643 15.2792C7.29437 15.5488 7.28886 16.0275 7.56981 16.3081C7.85627 16.5887 8.33553 16.5832 8.59995 16.3191L11.8612 13.0619L15.1169 16.3136C15.3923 16.5887 15.866 16.5887 16.147 16.3081C16.4279 16.022 16.4279 15.5543 16.1525 15.2792L12.8968 12.0276L16.1525 8.77036C16.4279 8.49526 16.4335 8.02208 16.147 7.74148C15.866 7.46088 15.3923 7.46088 15.1169 7.73598L11.8612 10.9877L8.59995 7.73598C8.33553 7.46638 7.85076 7.45537 7.56981 7.74148C7.28886 8.02208 7.29437 8.50626 7.5643 8.77036L10.82 12.0276L7.5643 15.2792Z",
    fill: "currentColor"
  })))), /*#__PURE__*/React.createElement(BootstrapModal.Body, null, /*#__PURE__*/React.createElement("div", {
    className: "loyalty-peg-modal__body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loyalty-peg-modal__image"
  }, /*#__PURE__*/React.createElement(Image, {
    field: image
  })), /*#__PURE__*/React.createElement("div", {
    className: "loyalty-peg-modal__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loyalty-peg-modal__content-peg"
  }, /*#__PURE__*/React.createElement(RichText, {
    field: copy,
    className: "loyalty-peg-modal__content-peg-copy"
  }), /*#__PURE__*/React.createElement("div", {
    className: "loyalty__peg-counter"
  }, backgroundShape && backgroundShape.value && backgroundShape.value !== "" && /*#__PURE__*/React.createElement(Image, {
    field: backgroundShape
  }), /*#__PURE__*/React.createElement("span", {
    className: "loyalty__peg-counter-desc"
  }, pegCounter && pegCounter.value !== "" && /*#__PURE__*/React.createElement("span", {
    className: "loyalty__peg-counter-value"
  }, /*#__PURE__*/React.createElement("span", null, pegCounter.value), /*#__PURE__*/React.createElement("img", {
    src: PegIcon,
    alt: pegIconAlt && pegIconAlt.value ? pegIconAlt.value : "Peg Icon",
    title: pegIconAlt && pegIconAlt.value ? pegIconAlt.value : "Peg Icon",
    className: "loyalty__peg-counter-value--icon"
  })), currencyCopy && currencyCopy.value !== "" && /*#__PURE__*/React.createElement("span", {
    className: "loyalty__peg-counter-label"
  }, currencyCopy.value)))), /*#__PURE__*/React.createElement("div", {
    className: "loyalty-peg-modal__content--title"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    field: {
      value: title ? title.value : ""
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "loyalty-peg-modal__content--copy"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    field: {
      value: description ? description.value : ""
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "loyalty-peg-modal__content--terms"
  }, /*#__PURE__*/React.createElement(RichText, {
    field: termsConditions,
    tag: "p"
  })), button && button.value !== "" && /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary loyalty-peg-modal__cta",
    onClick: closeModal
  }, button.value)))));
};

export default PegInformationModal;